module.exports = __webpack_public_path__ + "img/上海泰宝金属制品有限公司.adb286e1.jpg";